// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Tab = require("@mui/material/Tab").default;
var Tabs = require("@mui/material/Tabs").default;
var JsxPPXReactSupport = require("rescript/lib/js/jsxPPXReactSupport.js");
var Expln_utils_promise = require("../Expln_utils_promise.bs.js");
var IconButton = require("@mui/material/IconButton").default;
var Clear = require("@mui/icons-material/Clear").default;

function getNextId(st) {
  return [
          {
            nextId: st.nextId + 1 | 0,
            tabs: st.tabs,
            activeTabId: st.activeTabId,
            tabHistory: st.tabHistory
          },
          String(st.nextId)
        ];
}

function getTabs(st) {
  return st.tabs;
}

function addTab(st, label, closable, color, data, doOpenOpt, param) {
  var doOpen = doOpenOpt !== undefined ? doOpenOpt : false;
  var match = getNextId(st);
  var newId = match[1];
  var st$1 = match[0];
  var newTabs = st$1.tabs.concat([{
          id: newId,
          label: label,
          closable: closable,
          color: color,
          data: data
        }]);
  var newActiveTabId = newTabs.length === 1 || doOpen ? newId : st$1.activeTabId;
  var newTabHistory = newTabs.length === 1 ? [newId] : (
      doOpen ? st$1.tabHistory.concat([newId]) : st$1.tabHistory
    );
  return [
          {
            nextId: st$1.nextId,
            tabs: newTabs,
            activeTabId: newActiveTabId,
            tabHistory: newTabHistory
          },
          newId
        ];
}

function openTab(st, tabId) {
  if (st.tabs.some(function (t) {
          return t.id === tabId;
        })) {
    return {
            nextId: st.nextId,
            tabs: st.tabs,
            activeTabId: tabId,
            tabHistory: Belt_Option.mapWithDefault(Belt_Array.get(st.tabHistory, st.tabHistory.length - 1 | 0), false, (function (lastId) {
                    return lastId === tabId;
                  })) ? st.tabHistory : st.tabHistory.concat([tabId])
          };
  } else {
    return st;
  }
}

function removeTab(st, tabId) {
  var newTabs = st.tabs.filter(function (t) {
        return t.id !== tabId;
      });
  var newTabHistory = st.tabHistory.filter(function (id) {
        return id !== tabId;
      });
  return {
          nextId: st.nextId,
          tabs: newTabs,
          activeTabId: newTabs.length === 0 ? "" : (
              st.activeTabId === tabId ? Belt_Option.getWithDefault(Belt_Array.get(newTabHistory, newTabHistory.length - 1 | 0), Caml_array.get(newTabs, 0).id) : st.activeTabId
            ),
          tabHistory: newTabHistory
        };
}

function useTabs(param) {
  var match = React.useState(function () {
        return {
                nextId: 0,
                tabs: [],
                activeTabId: "",
                tabHistory: []
              };
      });
  var setState = match[1];
  var state = match[0];
  var addTab$1 = function (label, closable, color, data, doOpenOpt, param) {
    var doOpen = doOpenOpt !== undefined ? doOpenOpt : false;
    return Expln_utils_promise.promise(function (rlv) {
                Curry._1(setState, (function (prev) {
                        var match = addTab(prev, label, closable, color, data, doOpen, undefined);
                        Curry._1(rlv, match[1]);
                        return match[0];
                      }));
              });
  };
  var openTab$1 = function (id) {
    Curry._1(setState, (function (prev) {
            return openTab(prev, id);
          }));
  };
  var removeTab$1 = function (id) {
    Curry._1(setState, (function (prev) {
            return removeTab(prev, id);
          }));
  };
  var renderTabs = function (param) {
    var tabs = state.tabs;
    if (tabs.length === 0) {
      return null;
    } else {
      return React.createElement(Tabs, {
                  value: state.activeTabId,
                  onChange: (function (param, id) {
                      Curry._1(setState, (function (prev) {
                              return openTab(prev, id);
                            }));
                    }),
                  variant: "scrollable",
                  style: {
                    minHeight: "25px"
                  },
                  children: tabs.map(function (tab) {
                        var tmp = {
                          minHeight: "25px",
                          padding: "3px"
                        };
                        if (tab.color !== undefined) {
                          tmp.backgroundColor = tab.color;
                        }
                        return JsxPPXReactSupport.createElementWithKey(tab.id, Tab, {
                                    value: tab.id,
                                    style: tmp,
                                    label: Caml_option.some(tab.closable ? React.createElement("span", {
                                                style: {
                                                  textTransform: "none"
                                                }
                                              }, React.createElement("span", {
                                                    style: {
                                                      marginRight: "5px"
                                                    }
                                                  }, tab.label), React.createElement(IconButton, {
                                                    onClick: (function (evt) {
                                                        evt.stopPropagation();
                                                        var id = tab.id;
                                                        Curry._1(setState, (function (prev) {
                                                                return removeTab(prev, id);
                                                              }));
                                                      }),
                                                    style: {
                                                      padding: "0px"
                                                    },
                                                    component: "div",
                                                    children: Caml_option.some(React.createElement(Clear, {
                                                              fontSize: "small"
                                                            }))
                                                  })) : tab.label)
                                  });
                      })
                });
    }
  };
  return {
          addTab: addTab$1,
          openTab: openTab$1,
          removeTab: removeTab$1,
          tabs: state.tabs.slice(),
          activeTabId: state.activeTabId,
          renderTabs: renderTabs,
          updateTabs: Curry.__1(setState)
        };
}

exports.getTabs = getTabs;
exports.addTab = addTab;
exports.openTab = openTab;
exports.removeTab = removeTab;
exports.useTabs = useTabs;
/* react Not a pure module */
